import {ShortLocaleNameEnum} from '../../provider/locale/locale-context-type';

import {FeaturesEnum, UserType} from './user-type';

export const userUrl = '/user';

export const USER_FIXTURE: Omit<UserType, 'regionAvailableCatalogs'> = {
    id: 792,
    email: 'test@rocketdata.io',
    language: ShortLocaleNameEnum.en,
    isStaff: true,
    isDoubleGisUser: false,
    isDoubleGisTrusted: false,
    isTestUser: false,
    isDemoCpUser: false,
    is2faEnabled: false,
    isInternalAgency: false,
    profile: {
        firstName: 'Bob',
        isShowAutotags: false,
        timezone: '',
    },
};

export const FEATURES_FIXTURE = {
    features: Object.values(FeaturesEnum),
};
